import React from "react";
import s from "./Footer.module.scss";

type Props = {};

const Footer = (props: Props) => {
  return <div className={s.footer}> </div>;
};

export default Footer;
